// eslint-disable-next-line import/no-extraneous-dependencies
import { Plugin } from '@nuxt/types';

const pageGuards : Plugin = () => {
  // https://www.notion.so/fightcamp/Nuxt-Best-Practices-9735bcffeb4745e1a463b5a5014fa51f#b68ece0038094f98803291b336bb6036
};

export default pageGuards;
